import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItemsService } from 'src/app/services/menu-items.service';
import { RoutingService } from 'src/app/services/routing.service';

@Component({
  selector: 'app-ordinary-object-row',
  templateUrl: './ordinary-object-row.component.html',
  styleUrls: ['./ordinary-object-row.component.scss']
})

export class OrdinaryObjectRowComponent {
  @Input() title1: MultiLangStrDto | undefined;
  @Input() value1: MultiLangStrDto | undefined;
  @Input() title2: MultiLangStrDto | undefined;
  @Input() value2:MultiLangStrDto | undefined;
  @Input() title3: MultiLangStrDto | undefined;
  @Input() value3: MultiLangStrDto | undefined;
  @Input() isSeventhRow = false;
  @Output() handleClickHachraza = new EventEmitter<any>();


  constructor() { }

  clickHachraza($event: any): void {
    this.handleClickHachraza.emit($event);
  }
}
